import ENDPOINTS from '@/config/http/endpoints'
import type {
  CampaignLimit,
  CampaignsResponse
} from '@/ducks/campaigns/campaigns.types'
import { DEFAULT_CAMPAIGN_LIMIT } from '@/ducks/campaigns/campaigns.types'
import { rootApi } from '@/ducks/root.api'

export const parseCampaignsResponse = (
  response: CampaignsResponse
): CampaignsResponse => {
  if (!response || response.status !== 1) {
    throw new Error('Failed to fetch campaigns')
  }

  return response
}

export type FetchCampaignsQueryParams = {
  page?: number
  limit?: CampaignLimit
  skip?: number
  campaignType?: string
  status?: string
  dateRange?: 'week' | 'month'
  dateFrom?: string
  dateTo?: string
}

export const campaignsApi = rootApi.injectEndpoints({
  endpoints: build => ({
    fetchCampaigns: build.query<CampaignsResponse, FetchCampaignsQueryParams>({
      query: ({
        page = 0,
        limit = DEFAULT_CAMPAIGN_LIMIT,
        skip,
        campaignType,
        status,
        dateRange,
        dateFrom,
        dateTo
      }) => ({
        method: 'GET',
        url: ENDPOINTS.GET_CAMPAIGNS,
        params: {
          page,
          limit,
          ...(skip != null ? { skip } : {}),
          ...(campaignType ? { campaignType } : {}),
          ...(status ? { status } : {}),
          ...(dateRange ? { dateRange } : {}),
          ...(dateFrom && dateTo ? { dateFrom, dateTo } : {})
        }
      }),
      transformResponse: (response: CampaignsResponse) =>
        parseCampaignsResponse(response),
      providesTags: ['Campaigns']
    })
  })
})

export const { useFetchCampaignsQuery } = campaignsApi
